import React, { Fragment, useState, useEffect } from "react";
import { Spin, Select } from "antd";
import useFetch from "../../hooks/useFetch";
import { errorHandler } from "../../helpers/Utils";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../helpers/AsyncMessage";
import Axios from "axios";
import { IconChevronDown, IconChevronUp } from "../Layout/Icons";
import SwitchComp from "../common/SwitchComp";
import { MdEdit } from "react-icons/md";
import { BsFillXCircleFill } from "react-icons/bs";
import { FaCheckCircle } from "react-icons/fa";

import { TextInput } from "../globals";

const updateDisableStore = async (id, disabled) => {
  const key = "updateSettings";
  try {
    antdAsyncMessageLoading({ key });
    const { data } = await Axios.put(
      `/api/v1/retail_product_disabled_stores/${id}`,
      {
        retail_product_disabled_stores: {
          disabled,
        },
      }
    );
    if (!data.success) throw new Error("ERR");
    antdAsyncMessageSuccess({ key });

    return { success: true, data: data.data };
  } catch (err) {
    errorHandler(err);
    antdAsyncMessageError({ key, text: err?.response?.data?.message });
    return { success: false };
  }
};

function ModalImumCategorySettings() {
  console.log("rename: DisableStores");
  const {
    value: categories,
    setReFetch,
    loading,
  } = useFetch(`/api/v1/retail_product_disabled_stores/categories`);

  if (true) {
    return (
      <div className="mx-3">
        <div className="row border-b-silver py-2">
          <div className="col-2 pl-0 font-medium">Category</div>
          <div className="col-2 font-medium">Ignore the prime cost</div>
          <div className="col-2 font-medium">Price will be higher than BB</div>
          <div className="col-2 font-medium">Price change fuse</div>
          <div className="col-2 font-medium">Median gap</div>
          <div className="col-2 font-medium">Min cost</div>
        </div>
        {categories?.map((category) => {
          return (
            <ImumCategory
              key={category.id}
              variables={category}
              setReFetch={setReFetch}
              isLoading={loading}
            />
          );
        })}
      </div>
    );
  } else {
    return (
      <div className="mx-3">
        <div className="row border-b-silver py-2">
          <div className="col-3 pl-0 font-medium">Category</div>
          <div className="col-3 font-medium">Ignore the prime cost</div>
          <div className="col-2 font-medium">Price change fuse</div>
          <div className="col-2 font-medium">Median gap</div>
          <div className="col-2 font-medium">Min cost</div>
        </div>
        {categories?.map((category) => {
          return (
            <ImumCategory
              key={category.id}
              variables={category}
              setReFetch={setReFetch}
              isLoading={loading}
            />
          );
        })}
      </div>
    );
  }
}

export default ModalImumCategorySettings;

const ImumCategory = ({ variables, setReFetch, isLoading }) => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(variables.ignore_prime_cost);
  const [selectedValue, setSelectedValue] = useState(
    variables.lower_then_bb_val || "equal"
  );
  const [activeLowerThenBBFuse, setActiveLowerThenBBFuse] = useState(
    variables.lower_then_bb_fuse
  );
  const [isEdit, setIsEdit] = useState(false);
  const [isMedianEdit, setIsMedianEdit] = useState(false);
  const [isMinCostEdit, setIsMinCostEdit] = useState(false);

  const [price_diff_fuse, setPriceDiffFuse] = useState(
    variables.price_diff_fuse || ""
  );
  const [median, setMedian] = useState(
    variables.median || 30
  );
  const [min_cost, setMinCost] = useState(
    variables.min_cost
  );

  const updateCategory = async ({
    ignore_prime_cost,
    imum_category_id,
    price_diff_fuse,
    lower_then_bb_fuse,
    lower_then_bb_val,
    median,
    min_cost
  }) => {
    const payload = {
      ignore_prime_cost,
      imum_category_id,
      price_diff_fuse,
      lower_then_bb_fuse,
      lower_then_bb_val: lower_then_bb_val || selectedValue,
      median,
      min_cost,
    };
    // Remove unset (undefined / null) values
    const filteredPayload = Object.fromEntries(
      Object.entries(payload).filter(([_, v]) => v !== undefined)
    );

    const { data } = await Axios.post(
      `/api/v1/retail_product_disabled_stores/update_category`,
      filteredPayload
    );

    setReFetch();
    return data;
  };
  if (true) {
    return (
      <div>
        <div className={`row py-2 ${open ? "" : "border-b-silver"}`}>
          <div className="col-2 pl-0">{variables.title}</div>
          <div className="col-2 d-flex justify-content-between align-items-center">
            <div className="d-flex flex-row justify-content-between align-items-center">
              <SwitchComp
                className=""
                text={active ? "Yes" : "Inactive"}
                checked={active}
                onChange={async () => {
                  const key = `put_imum_category_${variables.id}`;
                  try {
                    antdAsyncMessageLoading({
                      key,
                      text: `Updating '${variables.title}'`,
                    });
                    const ignore_prime_cost = !active;
                    setActive(ignore_prime_cost);
                    const data = await updateCategory({
                      ignore_prime_cost: ignore_prime_cost,
                      imum_category_id: variables.id
                    });
                    console.log({ data });
                    antdAsyncMessageSuccess({
                      key,
                      text: `Successfully updated '${variables.title}'`,
                    });
                  } catch (err) {
                    antdAsyncMessageError({
                      key,
                      text: `Error updating '${variables.title}'`,
                    });
                  }
                }}
              />
            </div>
          </div>
          <div className="col-2 d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-between align-items-center">
              <SwitchComp
                className=""
                text={activeLowerThenBBFuse ? "" : "Inactive"}
                checked={activeLowerThenBBFuse}
                onChange={async () => {
                  const key = `lower_then_bb_fuse_${variables.id}`;
                  try {
                    antdAsyncMessageLoading({
                      key,
                      text: `Updating '${variables.title}'`,
                    });
                    const lower_then_bb_fuse = !activeLowerThenBBFuse;
                    setActiveLowerThenBBFuse(lower_then_bb_fuse);
                    const data = await updateCategory({
                      imum_category_id: variables.id,
                      lower_then_bb_fuse: lower_then_bb_fuse
                    });
                    console.log({ data });
                    antdAsyncMessageSuccess({
                      key,
                      text: `Successfully updated '${variables.title}'`,
                    });
                  } catch (err) {
                    antdAsyncMessageError({
                      key,
                      text: `Error updating '${variables.title}'`,
                    });
                  }
                }}
              />
              {activeLowerThenBBFuse && (
                <Select
                  value={selectedValue}
                  style={{ width: 90, marginLeft: 10 }}
                  onChange={async (value) => {
                    setSelectedValue(value);
                    await updateCategory({
                      imum_category_id: variables.id,
                      lower_then_bb_val: value
                    });
                  }}
                >
                  <Select.Option value="equal">Equal</Select.Option>
                  <Select.Option value="1eur">1 € more</Select.Option>
                  <Select.Option value="1%">1 % more</Select.Option>
                </Select>
              )}
            </div>
          </div>
          <div className="col-2 align-items-center">
            <div className="d-flex justify-content-between align-items-center">
              {!isEdit ? (
                <>
                  {isLoading ? (
                    <div style={{ height: 32 }}>
                      <Spin />
                    </div>
                  ) : (
                    <>
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ width: 90, height: 32 }}
                      >
                        <p
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                            color:
                              variables.price_diff_fuse !== null
                                ? "#000000"
                                : "#BFBFBF",
                            fontSize: 12,
                          }}
                        >
                          {variables.price_diff_fuse !== null
                            ? `${variables.price_diff_fuse}%`
                            : "Unset"}
                        </p>
                      </div>
                      <MdEdit
                        color="#5F5F5F"
                        width={15}
                        height={15}
                        onClick={() => {
                          setIsEdit(true);
                          setPriceDiffFuse(
                            variables.price_diff_fuse?.toString() || ""
                          );
                        }}
                      />
                      {variables.price_diff_fuse === null ? (
                        <div style={{ width: 15 }} />
                      ) : (
                        <BsFillXCircleFill
                          width={15}
                          height={15}
                          color="#C94747"
                          onClick={async () => {
                            setPriceDiffFuse("");
                            await updateCategory({
                              imum_category_id: variables.id,
                              price_diff_fuse: ""
                            });
                          }}
                        />
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <TextInput
                    type="number"
                    value={price_diff_fuse}
                    style={{ width: 90 }}
                    name="amount"
                    suffix={
                      <div>
                        <span>%</span>
                      </div>
                    }
                    onChange={(e) => setPriceDiffFuse(e.target.value)}
                  />
                  <FaCheckCircle
                    width={15}
                    height={15}
                    color="#28A745"
                    onClick={async () => {
                      const data = await updateCategory({
                        imum_category_id: variables.id,
                        price_diff_fuse: price_diff_fuse
                      });
                      console.log({ data });
                      setIsEdit(false);
                    }}
                  />
                  <BsFillXCircleFill
                    width={15}
                    height={15}
                    color="#C94747"
                    onClick={() => setIsEdit(false)}
                  />
                </>
              )}
            </div>
          </div>
          <div className="col-2 align-items-center">
            <div className="d-flex justify-content-between align-items-center">
              {!isMedianEdit ? (
                <>
                  {isLoading ? (
                    <div style={{ height: 32 }}>
                      <Spin />
                    </div>
                  ) : (
                    <>
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ width: 90, height: 32 }}
                      >
                        <p
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                            color:
                              variables.median !== null
                                ? "#000000"
                                : "#BFBFBF",
                            fontSize: 12,
                          }}
                        >
                          {variables.median !== null
                            ? `${variables.median}%`
                            : "Unset"}
                        </p>
                      </div>
                      <MdEdit
                        color="#5F5F5F"
                        width={15}
                        height={15}
                        onClick={() => {
                          setIsMedianEdit(true);
                          setMedian(
                            variables.median?.toInt() || 30
                          );
                        }}
                      />
                      {variables.median === null ? (
                        <div style={{ width: 15 }} />
                      ) : (
                        <BsFillXCircleFill
                          width={15}
                          height={15}
                          color="#C94747"
                          onClick={async () => {
                            setMedian(30);
                            await updateCategory({
                              imum_category_id: variables.id,
                              median: median
                            });
                          }}
                        />
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <TextInput
                    type="number"
                    value={median}
                    style={{ width: 90 }}
                    name="amount"
                    suffix={
                      <div>
                        <span>%</span>
                      </div>
                    }
                    onChange={(e) => setMedian(e.target.value)}
                  />
                  <FaCheckCircle
                    width={15}
                    height={15}
                    color="#28A745"
                    onClick={async () => {
                      const data = await updateCategory({
                        imum_category_id: variables.id,
                        median: median
                      });
                      console.log({ data });
                      setIsMedianEdit(false);
                    }}
                  />
                  <BsFillXCircleFill
                    width={15}
                    height={15}
                    color="#C94747"
                    onClick={() => setIsMedianEdit(false)}
                  />
                </>
              )}
            </div>
          </div>


          <div className="col-2 align-items-center">
            <div className="d-flex justify-content-between align-items-center">
              {!isMinCostEdit ? (
                <>
                  {isLoading ? (
                    <div style={{ height: 32 }}>
                      <Spin />
                    </div>
                  ) : (
                    <>
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ width: 90, height: 32 }}
                      >
                        <p
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                            color:
                              variables.min_cost !== null
                                ? "#000000"
                                : "#BFBFBF",
                            fontSize: 12,
                          }}
                        >
                          {variables.min_cost !== null
                            ? `${variables.min_cost} €`
                            : "Unset"}
                        </p>
                      </div>
                      <MdEdit
                        color="#5F5F5F"
                        width={15}
                        height={15}
                        onClick={() => {
                          setIsMinCostEdit(true);
                          setMinCost(
                            variables.min_cost?.toInt()
                          );
                        }}
                      />
                      {variables.min_cost === null ? (
                        <div style={{ width: 15 }} />
                      ) : (
                        <BsFillXCircleFill
                          width={15}
                          height={15}
                          color="#C94747"
                          onClick={async () => {
                            setMinCost(null);
                            await updateCategory({
                              imum_category_id: variables.id,
                              min_cost: null
                            });
                          }}
                        />
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <TextInput
                    type="number"
                    value={min_cost}
                    style={{ width: 90 }}
                    name="min_cost"
                    suffix={
                      <div>
                        <span>€</span>
                      </div>
                    }
                    onChange={(e) => setMinCost(e.target.value)}
                  />
                  <FaCheckCircle
                    width={15}
                    height={15}
                    color="#28A745"
                    onClick={async () => {
                      const data = await updateCategory({
                        imum_category_id: variables.id,
                        min_cost: min_cost
                      });
                      console.log({ data });
                      setIsMinCostEdit(false);
                    }}
                  />
                  <BsFillXCircleFill
                    width={15}
                    height={15}
                    color="#C94747"
                    onClick={() => setIsMinCostEdit(false)}
                  />
                </>
              )}

              <div
                onClick={() => {
                  setOpen((prev) => !prev);
                }}
              >
                {open ? (
                  <span className="text-danger">
                    <IconChevronUp />
                  </span>
                ) : (
                  <span className="text-success">
                    <IconChevronDown />
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        {open && (
          <div className="row">
            <div className="col-12 border-silver bg-l-silver rounded">
              <CatOpen
                category={variables.title}
                brands={variables?.brands}
                setReFetch={setReFetch}
              />
            </div>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div>
        <div className={`row py-2 ${open ? "" : "border-b-silver"}`}>
          <div className="col-3 pl-0">{variables.title}</div>
          <div className="col-3 d-flex justify-content-between align-items-center">
            <div className="d-flex flex-row justify-content-between align-items-center">
              <SwitchComp
                className=""
                text={active ? "Yes" : "Inactive"}
                checked={active}
                onChange={async () => {
                  const key = `put_imum_category_${variables.id}`;
                  try {
                    antdAsyncMessageLoading({
                      key,
                      text: `Updating '${variables.title}'`,
                    });
                    const ignore_prime_cost = !active;
                    setActive(ignore_prime_cost);
                    const data = await updateCategory({
                      ignore_prime_cost: ignore_prime_cost,
                      imum_category_id: variables.id
                    });
                    console.log({ data });
                    antdAsyncMessageSuccess({
                      key,
                      text: `Successfully updated '${variables.title}'`,
                    });
                  } catch (err) {
                    antdAsyncMessageError({
                      key,
                      text: `Error updating '${variables.title}'`,
                    });
                  }
                }}
              />
            </div>
          </div>
          <div className="col-2 align-items-center">
            <div className="d-flex justify-content-between align-items-center">
              {!isEdit ? (
                <>
                  {isLoading ? (
                    <div style={{ height: 32 }}>
                      <Spin />
                    </div>
                  ) : (
                    <>
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ width: 90, height: 32 }}
                      >
                        <p
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                            color:
                              variables.price_diff_fuse !== null
                                ? "#000000"
                                : "#BFBFBF",
                            fontSize: 12,
                          }}
                        >
                          {variables.price_diff_fuse !== null
                            ? `${variables.price_diff_fuse}%`
                            : "Unset"}
                        </p>
                      </div>
                      <MdEdit
                        color="#5F5F5F"
                        width={15}
                        height={15}
                        onClick={() => {
                          setIsEdit(true);
                          setPriceDiffFuse(
                            variables.price_diff_fuse?.toString() || ""
                          );
                        }}
                      />
                      {variables.price_diff_fuse === null ? (
                        <div style={{ width: 15 }} />
                      ) : (
                        <BsFillXCircleFill
                          width={15}
                          height={15}
                          color="#C94747"
                          onClick={async () => {
                            setPriceDiffFuse("");
                            await updateCategory({
                              imum_category_id: variables.id,
                              price_diff_fuse: ""
                            });
                          }}
                        />
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <TextInput
                    type="number"
                    value={price_diff_fuse}
                    style={{ width: 90 }}
                    name="amount"
                    suffix={
                      <div>
                        <span>%</span>
                      </div>
                    }
                    onChange={(e) => setPriceDiffFuse(e.target.value)}
                  />
                  <FaCheckCircle
                    width={15}
                    height={15}
                    color="#28A745"
                    onClick={async () => {
                      const data = await updateCategory({
                        imum_category_id: variables.id,
                        price_diff_fuse: price_diff_fuse
                      });
                      console.log({ data });
                      setIsEdit(false);
                    }}
                  />
                  <BsFillXCircleFill
                    width={15}
                    height={15}
                    color="#C94747"
                    onClick={() => setIsEdit(false)}
                  />
                </>
              )}
            </div>
          </div>
          <div className="col-2 align-items-center">
            <div className="d-flex justify-content-between align-items-center">
              {!isMedianEdit ? (
                <>
                  {isLoading ? (
                    <div style={{ height: 32 }}>
                      <Spin />
                    </div>
                  ) : (
                    <>
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ width: 90, height: 32 }}
                      >
                        <p
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                            color:
                              variables.median !== null
                                ? "#000000"
                                : "#BFBFBF",
                            fontSize: 12,
                          }}
                        >
                          {variables.median !== null
                            ? `${variables.median}%`
                            : "Unset"}
                        </p>
                      </div>
                      <MdEdit
                        color="#5F5F5F"
                        width={15}
                        height={15}
                        onClick={() => {
                          setIsMedianEdit(true);
                          setMedian(
                            variables.median?.toInt() || 30
                          );
                        }}
                      />
                      {variables.median === null ? (
                        <div style={{ width: 15 }} />
                      ) : (
                        <BsFillXCircleFill
                          width={15}
                          height={15}
                          color="#C94747"
                          onClick={async () => {
                            setMedian(30);
                            await updateCategory({
                              imum_category_id: variables.id,
                              median: median
                            });
                          }}
                        />
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <TextInput
                    type="number"
                    value={median}
                    style={{ width: 90 }}
                    name="amount"
                    suffix={
                      <div>
                        <span>%</span>
                      </div>
                    }
                    onChange={(e) => setMedian(e.target.value)}
                  />
                  <FaCheckCircle
                    width={15}
                    height={15}
                    color="#28A745"
                    onClick={async () => {
                      const data = await updateCategory({
                        imum_category_id: variables.id,
                        median: median
                      });
                      console.log({ data });
                      setIsMedianEdit(false);
                    }}
                  />
                  <BsFillXCircleFill
                    width={15}
                    height={15}
                    color="#C94747"
                    onClick={() => setIsMedianEdit(false)}
                  />
                </>
              )}
            </div>
          </div>
          <div className="col-2 align-items-center">
            <div className="d-flex justify-content-between align-items-center">
              {!isMinCostEdit ? (
                <>
                  {isLoading ? (
                    <div style={{ height: 32 }}>
                      <Spin />
                    </div>
                  ) : (
                    <>
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ width: 90, height: 32 }}
                      >
                        <p
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                            color:
                              variables.min_cost !== null
                                ? "#000000"
                                : "#BFBFBF",
                            fontSize: 12,
                          }}
                        >
                          {variables.min_cost !== null
                            ? `${variables.min_cost} €`
                            : "Unset"}
                        </p>
                      </div>
                      <MdEdit
                        color="#5F5F5F"
                        width={15}
                        height={15}
                        onClick={() => {
                          setIsMinCostEdit(true);
                          setMinCost(
                            variables.min_cost?.toInt()
                          );
                        }}
                      />
                      {variables.min_cost === null ? (
                        <div style={{ width: 15 }} />
                      ) : (
                        <BsFillXCircleFill
                          width={15}
                          height={15}
                          color="#C94747"
                          onClick={async () => {
                            setMinCost(null);
                            await updateCategory({
                              imum_category_id: variables.id,
                              min_cost: min_cost
                            });
                          }}
                        />
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <TextInput
                    type="number"
                    value={min_cost}
                    style={{ width: 90 }}
                    name="min_cost"
                    suffix={
                      <div>
                        <span>€</span>
                      </div>
                    }
                    onChange={(e) => setMinCost(e.target.value)}
                  />
                  <FaCheckCircle
                    width={15}
                    height={15}
                    color="#28A745"
                    onClick={async () => {
                      const data = await updateCategory({
                        imum_category_id: variables.id,
                        min_cost: min_cost
                      });
                      console.log({ data });
                      setIsMinCostEdit(false);
                    }}
                  />
                  <BsFillXCircleFill
                    width={15}
                    height={15}
                    color="#C94747"
                    onClick={() => setIsMinCostEdit(false)}
                  />
                </>
              )}

              <div
                onClick={() => {
                  setOpen((prev) => !prev);
                }}
              >
                {open ? (
                  <span className="text-danger">
                    <IconChevronUp />
                  </span>
                ) : (
                  <span className="text-success">
                    <IconChevronDown />
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        {open && (
          <div className="row">
            <div className="col-12 border-silver bg-l-silver rounded">
              <CatOpen
                category={variables.title}
                brands={variables?.brands}
                setReFetch={setReFetch}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
};

const bulkUpdateStores = async (ids, disabled) => {
  const key = "bulkUpdateStores";
  try {
    antdAsyncMessageLoading({ key });
    const payload = {
      ids: ids,
      retail_product_disabled_stores: {
        disabled: disabled
      }
    };

    const { data } = await Axios.post(
      `/api/v1/retail_product_disabled_stores/bulk_update`,
      payload
    );
    if (!data.success) throw new Error("Bulk update failed");
    antdAsyncMessageSuccess({ key });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdAsyncMessageError({ key, text: err?.response?.data?.message });
    return { success: false };
  }
};

const CatOpen = ({ category, brands, setReFetch }) => {
  const { loading, error, value, setValue } = useFetch(
    `/api/v1/retail_product_disabled_stores?imum_category=${encodeURIComponent(category)}`
  );
  const [isStore, setIsStore] = useState(true);
  const [selectedLocale, setSelectedLocale] = useState(null);

  const onHandleDisabled = async (id, remove) => {
    const { success } = await updateDisableStore(id, remove);
    if (!success) return;
    setValue((prev) => {
      return prev.map((d) => (d.id == id ? { ...d, disabled: remove } : d));
    });
  };

  const filteredStores = selectedLocale
    ? value?.filter(store => store.country === selectedLocale)
    : value;

  const handleBulkStatusUpdate = async (disabled) => {
    const storeIds = filteredStores?.map(store => store.id) || [];
    if (storeIds.length === 0) return;

    const { success } = await bulkUpdateStores(storeIds, disabled);
    if (success) {
      setValue((prev) =>
        prev.map(store =>
          selectedLocale ?
            (store.country === selectedLocale ? { ...store, disabled } : store) :
            { ...store, disabled }
        )
      );
    }
  };
  return (
    <div>
      {loading ? (
        <div className="text-center my-4">
          <Spin />
        </div>
      ) : error ? (
        <div>{JSON.stringify(error)}</div>
      ) : (
        <Fragment>
          {value.length == 0 ? (
            <div className="d-flex align-items-center justify-content-center py-2 text-sm">
              No data...
            </div>
          ) : (
            <div>
              <div className="row border-b-silver py-2">
                <div onClick={() => setIsStore(true)} className={`col-2`}>
                  <p
                    className={isStore ? "p-style-active" : "p-style-inactive"}
                  >
                    <span className={`${isStore ? "border-bottom-blue" : ""}`}>
                      Store
                    </span>
                  </p>
                </div>
                <div onClick={() => setIsStore(false)} className={`col-2`}>
                  <p
                    className={isStore ? "p-style-inactive" : "p-style-active"}
                  >
                    <span className={`${isStore ? "" : "border-bottom-blue"}`}>
                      Brand
                    </span>
                  </p>
                </div>
                <div
                  className={`${isStore ? "col-3" : "col-4"
                    } font-medium d-flex justify-content-center align-items-center`}
                >
                  {`${isStore ? "Status" : "Brand status"}`}{" "}
                  {!isStore ? (
                    <Select
                      placeholder="Bulk Status"
                      style={{ width: 110, marginLeft: 10 }}
                      onChange={async (value) => {
                        const brandIds = brands?.map(brand => brand.id) || [];
                        if (brandIds.length > 0) {
                          try {
                            const { data } = await Axios.post(
                              `/api/v1/retail_product_disabled_stores/update_brand`,
                              {
                                brand_id: brandIds,
                                active: value === 'enable_all'
                              }
                            );
                            if (data.success) {
                              setReFetch(prev => prev + 1);
                            }
                          } catch (err) {
                            console.error('Error updating brands:', err);
                          }
                        }
                      }}
                    >
                      <Select.Option value="enable_all">Enable All</Select.Option>
                      <Select.Option value="disable_all">Disable All</Select.Option>
                    </Select>
                  ) : null}
                </div>
                {isStore && (
                  <div className="col-2 font-medium d-flex justify-content-center align-items-center">
                    <Select
                      value={selectedLocale}
                      placeholder="Locale"
                      allowClear
                      style={{ width: 80 }}
                      onChange={(value) => setSelectedLocale(value)}
                    >
                      <Select.Option value="lt">LT</Select.Option>
                      <Select.Option value="lv">LV</Select.Option>
                      <Select.Option value="fi">FI</Select.Option>
                      <Select.Option value="ee">EE</Select.Option>
                    </Select>
                  </div>
                )}
                {isStore && (
                  <div className="col-3 font-medium d-flex justify-content-center align-items-center">
                    <Select
                      placeholder="Bulk Actions"
                      style={{ width: 130 }}
                      onChange={async (value) => {
                        if (value === 'enable_all') {
                          await handleBulkStatusUpdate(false);
                        } else if (value === 'disable_all') {
                          await handleBulkStatusUpdate(true);
                        }
                      }}
                    >
                      <Select.Option value="enable_all">Enable All</Select.Option>
                      <Select.Option value="disable_all">Disable All</Select.Option>
                    </Select>
                  </div>
                )}

                {!isStore && (
                  <div className="col-4 font-medium d-flex justify-content-center align-items-center">
                    {`${"Priority"}`}{" "}
                    <Select
                      placeholder="Bulk Priority"
                      style={{ width: 110, marginLeft: 10 }}
                      onChange={async (value) => {
                        const brandIds = brands?.map(brand => brand.id) || [];
                        if (brandIds.length > 0) {
                          try {
                            const { data } = await Axios.post(
                              `/api/v1/retail_product_disabled_stores/update_brand`,
                              {
                                brand_id: brandIds,
                                priority_product: value === 'enable_priority'
                              }
                            );
                            if (data.success) {
                              setReFetch(prev => prev + 1);
                            }
                          } catch (err) {
                            console.error('Error updating brand priorities:', err);
                          }
                        }
                      }}
                    >
                      <Select.Option value="enable_priority">Enable Priority</Select.Option>
                      <Select.Option value="disable_priority">Disable Priority</Select.Option>
                    </Select>
                  </div>
                )}
              </div>
              {isStore ? (
                <div className="row">
                  {filteredStores?.map((d) => {
                    return (
                      <ShopItem
                        key={d.id}
                        {...d}
                        onChange={() => onHandleDisabled(d.id, !d.disabled)}
                      />
                    );
                  })}
                </div>
              ) : (
                <div className="row">
                  {brands?.map((d) => {
                    console.log(d, "brands");
                    return (
                      <BrandItem
                        key={d.id}
                        id={d.id}
                        title={d.title}
                        active={d.active}
                        setReFetch={setReFetch}
                        priorityProduct={d.priority_product}
                        onChange={() => onHandleDisabled(d.id, !d.disabled)}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </Fragment>
      )}
    </div>
  );
};

const ShopItem = ({ country, shop, disabled, onChange }) => (
  <>
    <div className="col-3 py-1 border-bottom border-muted">
      {" "}
      <b className="mr-2">{country}</b> {shop}
    </div>
    <div
      className="col-4 py-1 border-bottom border-muted cursor-pointer expand-hover justify-content-center d-flex"
      onClick={onChange}
    >
      {disabled ? (
        <span className="text-danger">Disabled</span>
      ) : (
        <span className="text-success">Available</span>
      )}
    </div>
    <div className="col-5 py-1 border-bottom border-muted"></div>
  </>
);

const BrandItem = ({ id, title, active, setReFetch, priorityProduct }) => {
  const [isActive, setIsActive] = useState(active);
  const [isPriorityProduct, setIsPriorityProduct] = useState(priorityProduct);

  useEffect(() => {
    setIsActive(active);
  }, [active]);

  useEffect(() => {
    setIsPriorityProduct(priorityProduct);
  }, [priorityProduct]);
  const updateBrand = async (brand_id, active, priority_product) => {
    const { data } = await Axios.post(
      `/api/v1/retail_product_disabled_stores/update_brand`,
      {
        brand_id,
        active,
        priority_product,
      }
    );
    setReFetch();
    return data;
  };

  return (
    <>
      <div className="col-3 py-1 border-bottom border-muted">{title}</div>
      <div className="col-4 py-1 justify-content-center d-flex">
        <SwitchComp
          className=""
          text={isActive ? "Yes" : "Inactive"}
          checked={isActive}
          onChange={async () => {
            const key = `put_imum_brand_${id}`;
            try {
              antdAsyncMessageLoading({
                key,
                text: `Updating '${title}'`,
              });
              const data = await updateBrand(id, !isActive, isPriorityProduct);
              setIsActive(() => !isActive);
              antdAsyncMessageSuccess({
                key,
                text: `Successfully updated '${title}'`,
              });
            } catch (err) {
              antdAsyncMessageError({
                key,
                text: `Error updating '${title}'`,
              });
            }
          }}
        />
      </div>
      <div className="col-5 py-1 justify-content-center d-flex">
        <SwitchComp
          className=""
          text={isPriorityProduct ? "Yes" : "Inactive"}
          checked={isPriorityProduct}
          onChange={async () => {
            const key = `put_imum_brand_${id}`;
            try {
              antdAsyncMessageLoading({
                key,
                text: `Updating '${title}'`,
              });
              const data = await updateBrand(id, isActive, !isPriorityProduct);
              setIsPriorityProduct(() => !isPriorityProduct);
              antdAsyncMessageSuccess({
                key,
                text: `Successfully updated '${title}'`,
              });
            } catch (err) {
              antdAsyncMessageError({
                key,
                text: `Error updating '${title}'`,
              });
            }
          }}
        />
      </div>
    </>
  );
};
// const ShopItem = ({ country, shop, disabled, onChange }) => (
//   <div className="d-flex justify-content-between align-items-center mb-2 border-bottom border-muted">
//     <div>
//       <b className="mr-2">{country}</b> {shop}
//     </div>
//     <div className="cursor-pointer expand-hover mx-2" onClick={onChange}>
//       {disabled ? (
//         <span className="text-danger">Disabled</span>
//       ) : (
//         <span className="text-success">Available</span>
//       )}
//     </div>
//   </div>
// );
